// extracted by mini-css-extract-plugin
export default {"print-settings-grid":"PrintSettings__print-settings-grid___1YF0Z","print-settings-grid-left":"PrintSettings__print-settings-grid-left___3-YZ2"};